import type { AuthProvider } from '@refinedev/core';
import { apiClient, tokenManager } from '../lib/api-client';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    try {
      const response = await apiClient.post('/admin/auth/login', {
        username,
        password,
      });

      const { accessToken, refreshToken, user } = response.data;

      tokenManager.setToken(accessToken);
      tokenManager.setRefreshToken(refreshToken);
      tokenManager.setUser(user);

      return {
        success: true,
        redirectTo: '/',
      };
    } catch (error: unknown) {
      const message =
        (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        "Login yoki parol noto'g'ri";

      return {
        success: false,
        error: {
          name: 'LoginError',
          message,
        },
      };
    }
  },

  logout: async () => {
    try {
      const refreshToken = tokenManager.getRefreshToken();
      if (refreshToken) {
        await apiClient.post('/admin/auth/logout', { refreshToken });
      }
    } catch {
      // Ignore logout errors
    } finally {
      tokenManager.clearAll();
    }

    return {
      success: true,
      redirectTo: '/login',
    };
  },

  check: async () => {
    const token = tokenManager.getToken();

    if (!token) {
      return {
        authenticated: false,
        redirectTo: '/login',
      };
    }

    try {
      // Verify token by fetching current user
      const response = await apiClient.get('/admin/auth/me');
      tokenManager.setUser(response.data);

      return {
        authenticated: true,
      };
    } catch {
      tokenManager.clearAll();
      return {
        authenticated: false,
        redirectTo: '/login',
      };
    }
  },

  getPermissions: async () => {
    const user = tokenManager.getUser();
    return user?.permissions || null;
  },

  getIdentity: async () => {
    const user = tokenManager.getUser();

    if (!user) {
      return null;
    }

    return {
      id: user.id,
      name: user.fullName || user.username,
      avatar: user.avatar,
      ...user,
    };
  },

  onError: async (error) => {
    if ((error as { status?: number })?.status === 401) {
      return {
        logout: true,
        redirectTo: '/login',
      };
    }

    return { error };
  },
};
